/*
 * © 2020 Microsoft. All rights reserved.
 */

define('MenuUI/htp/HtpScreen',['pixi',
	'absolute',
	'absolute/screenmetrics',
	'lodash',
	'gameconfig',
	'MenuUI/MenuTile',
	'MenuUI/Menu',
	'MenuUI/MultiPageMenu',
	'MenuUI/htp/HtpTile',
	'MenuUI/SideBar',
	'MenuUI/ControlFocusManager',
	'Managers/ScaleManager',
	'Managers/ScrollManager',
	'Solitaire/SolitaireGameMode'
],
	function (
		PIXI, Absolute, ScreenMetrics, _, GameConfig, MenuTile,
		Menu, MultiPageMenu, HtpTile, SideBar, ControlFocusManager, ScaleManager, ScrollManager, SolitaireGameMode
	) {
		var HtpScreen = function (ui, game) {
			this.initHtpScreen(ui, game);
		};

		HtpScreen.prototype = Object.create(Absolute.Screen.prototype);

		HtpScreen.prototype.initHtpScreen = function (ui, game) {


			this.clickHandler = this.handleGameInput.bind(this);

			window.addEventListener('click', this.clickHandler);

			Absolute.Screen.call(this);

			this.ui = ui;
			this.game = game;

			this.controlFocusManager = new ControlFocusManager();

			ScaleManager.addElement(this, { scaleChangeSource: 'Full' });

			var background = PIXI.Sprite.fromFrame('win10_MS_bg.png');
			this.addChild(background);
            this.background.scale.set(
				1 / Math.min(ScaleManager.scaleFactorX, 1), 1 / Math.min(1, ScaleManager.scaleFactorY)
			);

		};

		HtpScreen.prototype.initSidebar = function () {
			this.sidebar = new SideBar({
				availableHeight: 200, partialHeight: 100,
				onScrollUpdate: function (p) {
				}.bind(this)
			});
			this.addChild(this.sidebar);
			this.sidebar.position.set(Absolute.Coords.x(1900), Absolute.Coords.y(67));
			this.updateSidebar();
		};

		HtpScreen.prototype.updateSidebar = function () {

			if (!this.sidebar || !this.scrollable) return;
			var height = this.game.menuBar.menuBarHeight;
			var screenScaleX = ScaleManager.width / Absolute.Coords.x(1920),
				screenScaleY = ScaleManager.height / Absolute.Coords.y(1080);
			this.sidebar.scale.set(1, 1);
			this.sidebar.width = this.sidebar.width / screenScaleX;
			this.sidebar.height = this.sidebar.height / screenScaleY;
			this.sidebar.y = height / screenScaleY;
			this.sidebar.x = Absolute.Coords.x(1900) - (this.sidebar.width - (this.sidebar.width * screenScaleX));
			var availableHeight, partialHeight, posY;
			availableHeight = this.scrollableFakeHeight;
			partialHeight = Absolute.Coords.x(1080);
			posY = availableHeight - Absolute.Coords.y(1080);
			this.sidebar.resetDimensions(availableHeight, partialHeight, function (p) {
				var y = -Math.abs(posY) * p / 100;
				this.scrollable.y = y;
				if (this.scrollable.y > 0) this.scrollable.y = 0;
				if (Math.abs(this.scrollable.y) > posY) {
					this.scrollable.y = -posY;
				}
			}.bind(this), (ScaleManager.height - height));
			this.sidebar.visible = (partialHeight < availableHeight);
			this.sidebar.updateHandleByPercent(100 * Math.abs(this.scrollable.y) / Math.abs(posY));
		};

		HtpScreen.prototype.handleResize = function () {
			if (!this.scrollable) return;
			this.scrollTo(this.scrollable.y);
			this.scrollable.height = (Absolute.Coords.y(985) / ScaleManager.height)
				* (ScaleManager.width / Absolute.Coords.x(1920)) * this.currentHeight;
			this.container.y = (this.game.menuBar.menuButton.y + this.game.menuBar.menuButton.height)
				* (Absolute.Coords.x(1920) / ScaleManager.width) * (ScaleManager.height / Absolute.Coords.y(980));
			this.scrollableFakeHeight = this.scrollable.height + Absolute.Coords.x(150);
			if ((this.scrollable.y < 0) && ((this.scrollableFakeHeight + this.scrollable.y) < Absolute.Coords.y(1080))) {
				this.scrollable.y = Absolute.Coords.y(1080) - this.scrollableFakeHeight;
			}
            this.background.scale.set(
				1 / Math.min(ScaleManager.scaleFactorX, 1), 1 / Math.min(1, ScaleManager.scaleFactorY)
			);
			this.updateSidebar();
		};

		HtpScreen.prototype.onShow = function () {

			this.ui.showLoadingScreen();

			Absolute.Screen.prototype.onShow.call(this);
			var levelLoader = new Absolute.Loader(),
				atlases = [
					{ name: 'htp_' + this.mode.toLowerCase() }
				];

			levelLoader.loadArt(atlases, function (percentComplete) {
				this.ui.loadingScreen.updateLoadingProgress(percentComplete);
			}.bind(this),
				function () {
					this.ui.loadingScreen.finishLoadingProgress();
					this.ui.loadingScreen.resetLoadingProgress();

					// this.mode = this.getModeNameInPascal(modeName.toLowerCase());

					this.htpContentLayer = new PIXI.DisplayObjectContainer();
					this.buildMenu();
					this.addChild(this.htpContentLayer);
					this.addChild(this.game.menuBar);
					this.game.menuBar.onShow(true, true, false, Absolute.StringManager('titles.howToPlay') + ' ' + Absolute.StringManager('tiles.' + this.mode));
					this.ui.hideLoadingScreen();
					this.ui.refreshBackground = true;
					this.currentHeight = this.scrollable.height + Absolute.Coords.y(150);
					this.handleResize();
					this.handleResize();

				}.bind(this));
			ScrollManager.add(this, this.doScroll, this);
		};

		HtpScreen.prototype.initTouchInterface = function () {
			// Dragging and panning
			this.lastDeltaY = 0;
			this.startY = 0;
			var hitArea = new PIXI.Rectangle(0, 0, Absolute.Coords.x(1920), Absolute.Coords.y(1080));
			this.touchContainer = new PIXI.DisplayObjectContainer();
			this.touchContainer.interactive = true;
			this.touchContainer.hitArea = hitArea;
			this.touchContainer.addChild(this.scrollable);
			this.touchContainer.mousedown = this.touchContainer.touchstart = this.handleDragStart.bind(this);
			this.touchContainer.mousemove = this.touchContainer.touchmove = this.handleDrag.bind(this);
			this.touchContainer.mouseupoutside = this.touchContainer.mouseup = this.touchContainer.touchend = this.touchContainer.touchendoutside = this.handleDragEnd.bind(this);
			this.addChild(this.touchContainer);

		};

		HtpScreen.prototype.handleDragStart = function (data) {
			this.dragging = true;
			this.lastDeltaY = 0;
			this.startY = data.getLocalPosition(this.parent).y;
			this.enableButtons(false);
		};

		HtpScreen.prototype.handleDrag = function (data) {

			if (!this.dragging) {
				return;
			}

			var pos = data.getLocalPosition(this.parent),
				delta = pos.y - this.startY;

			this.scrollTo(this.scrollable.y + ((delta - this.lastDeltaY) * ScreenMetrics.devicePixelRatio));

			this.lastDeltaY = delta;
		};

		HtpScreen.prototype.handleDragEnd = function (data) {

			if (!this.dragging) {
				return;
			}
			this.dragging = false;
		};

		HtpScreen.prototype.enableButtons = function (enable) {

			var i, l;

			for (i = 0, l = this.scrollable.children.length; i < l; i++) {
				this.scrollable.children[i].interactive = enable;
			}

		};

		HtpScreen.prototype.onHide = function () {
			Absolute.Screen.prototype.onHide.call(this);
			ScrollManager.remove(this);
			if (this.htpContentLayer) {
				// Absolute.SpriteUtils.destroyAllChildren(this.htpContentLayer);
				// Absolute.SpriteUtils.removeAllChildren(this.htpContentLayer);
				this.htpContentLayer.removeChild(this.paginatedMenu);
				this.removeChild(this.htpContentLayer);
				this.htpContentLayer = null;
				this.paginatedMenu = null;
			}
			if (this.sidebar) {
				this.removeChild(this.sidebar);
				this.sidebar = null;
			}
			this.htpTexts = null;
			this.scrollable.children = [];
			this.controlFocusManager.removeAllControls();
			this.sectionSelected = false;
			this.removeChild(this.sidebar);
		};

		HtpScreen.prototype.handleOrientationChange = function (isPortrait) {
			Absolute.Screen.prototype.handleOrientationChange.call(this, isPortrait);
		};

		HtpScreen.prototype.buildMenu = function () {
			this.initControls();
			var pageConfigs = _.cloneDeep(GameConfig.UI.htpLayouts[this.mode]),
				htpPages = [],
				tileColors = {
					"Klondike": 0x1cb2e5,
					"Spider": 0xa375e4,
					"FreeCell": 0xd24545,
					"Pyramid": 0xf88a24,
					"TriPeaks": 0x7cb127,
					"DailyChallenge": 0x137dc9,
					"StarClub": 0x010554
				};

			_.each(pageConfigs, function (tileConfigs, pageIndex) {
				var isFirst;
				var page;

				if (!Absolute.Platform.isMobile()) {
					isFirst = pageIndex === 'page1';
					page = new PIXI.DisplayObjectContainer();
				}

				_.each(tileConfigs, function (tileConfig, index) {

					if (Absolute.Platform.isMobile()) {
						isFirst = pageIndex === 'page1';
						page = new PIXI.DisplayObjectContainer();
					}

					// if(_.isString(tileConfig.image)) {
					var tileTexture = new PIXI.DisplayObjectContainer(),
						htpImage = PIXI.Sprite.fromFrame(tileConfig.image),
						tileBackground = new PIXI.Graphics(),
						htpTile;
					!Absolute.Platform.isMobile() ? htpImage.scale.set(0.9, 0.9) :
						(htpPages.length > 0 || index > 0) ? htpImage.scale.set(2, 2) : htpImage.scale.set(2.54, 2.54);
					tileConfig.headline = this.getText(tileConfig.text, 'headline', tileConfig.genericText);
					tileConfig.description = this.getText(tileConfig.text, 'description', tileConfig.genericText);

					if (tileConfig.needTitle) {
						var style = {
							font: Absolute.ScreenMetrics.getResScale() * 25 * 5 + 'px Arial',
							fontFamily: 'segoe',
							fill: '#ffffff',
							align: 'center'
						};
						var title = new PIXI.Text(tileConfig.headline, style);
						Absolute.StringManager.shrinkToFit(title, Absolute.ScreenMetrics.getResScale() * 25 * 5, '', Absolute.Coords.x(120 * 5));
						title.anchor.set(0.5, 0.5);
						title.x = htpImage.width / 2 + Absolute.Coords.x(15);
						title.y = htpImage.height / 2 + Absolute.Coords.y(108);
						htpImage.addChild(title);
					}

					tileBackground.beginFill(tileColors[this.mode]);
					tileBackground.drawRect(0, 0,
						!Absolute.Platform.isMobile() && (htpPages.length > 0 || index > 0) ? Absolute.Coords.x(820) : Absolute.Coords.x(1664),
						!Absolute.Platform.isMobile() ? Absolute.Coords.y(352) : (htpPages.length > 0 || index > 0) ? Absolute.Coords.y(352 * 2) : Absolute.Coords.y(352 * 4));
					tileBackground.endFill();
					tileTexture.addChild(tileBackground);
					htpImage.x = Absolute.Coords.x(20);
					htpImage.y = Absolute.Coords.x(32);
					tileTexture.addChild(htpImage);
					tileConfig.image = new PIXI.Sprite(tileTexture.generateTexture());
					// }

					if (Absolute.Platform.isMobile()) {
						htpTile = new HtpTile(tileConfig, false); // mobile has standard layout
						htpTile.x = 0;
						htpTile.y = 0;

					} else {
						htpTile = new HtpTile(tileConfig, isFirst && index === 0);
						if (htpPages.length === 0) { //page 1 layout is different
							htpTile.x = index > 1 ? Absolute.Coords.x(846) : 0;
							htpTile.y = index > 0 ? Absolute.Coords.y(376) : 0;
						} else {
							htpTile.x = index % 2 === 0 ? 0 : Absolute.Coords.x(846);
							htpTile.y = index > 1 ? Absolute.Coords.y(376) : 0;
						}
					}

					this.controlFocusManager.addControl(htpTile, false, 'HtpPage');

					page.addChild(htpTile);
					if (Absolute.Platform.isMobile()) {
						htpPages.push(page);
					}
				}, this);


				if (!Absolute.Platform.isMobile()) {
					htpPages.push(page);
				}
			}, this);

			this.scrollable = new PIXI.DisplayObjectContainer();
			this.container = new PIXI.DisplayObjectContainer();

			if (!Absolute.Platform.isMobile()) {
				for (var i = 0; i < htpPages.length; i++) {
					var page = htpPages[i],
						pagePosY = htpPages[i - 1] ? htpPages[i - 1].y + htpPages[i - 1].height : Absolute.Coords.y(50);
					page.x = Absolute.Coords.x(110);
					page.y = pagePosY;
					this.container.addChild(page)
				}
			} else {
				for (var i = 0; i < htpPages.length; i++) {
					var page = htpPages[i],
						pagePosY = htpPages[i - 1] ? htpPages[i - 1].y + htpPages[i - 1].height : Absolute.Coords.y(50);
					page.x = Absolute.Coords.x(110);
					page.y = pagePosY;
					this.container.addChild(page)
				}
			}

			this.scrollable.addChild(this.container);

			this.htpContentLayer.addChild(this.scrollable);

			this.initTouchInterface();

			this.initSidebar();
		};

		HtpScreen.prototype.initControls = function () {
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[0], false, 'LeftButtons');
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[1], false, 'LeftButtons');
			if (this.game.menuBar.fullScreenEnabled) {
				this.controlFocusManager.addControl(this.game.menuBar.controlGroup[3], false, 'RightButtons');
			}
		};

		HtpScreen.prototype.getText = function (key, type, generic) {

			if (!this.htpTexts) {
				this.htpTexts = Absolute.StringManager('howToPlay.' + this.mode.toLowerCase(), null, true);
				this.htpGenericTexts = Absolute.StringManager('howToPlay.general', null, true);
			}

			return _.find(generic ? this.htpGenericTexts : this.htpTexts, { 'id': key })[type];

		};

		HtpScreen.prototype.scrollTo = function (y) {
			if (!this.scrollable) return;
			if (this.scrollableFakeHeight <= Absolute.Coords.y(1080)) {
				this.scrollable.y = 0;
				return;
			}
			this.scrollable.y = y;
			if (this.scrollable.y > 0) this.scrollable.y = 0;
			var posY = this.scrollableFakeHeight - Absolute.Coords.y(1080);
			if (Math.abs(this.scrollable.y) > posY) {
				this.scrollable.y = -posY;
			}
			if (this.sidebar) this.sidebar.updateHandleByPercent(100 * Math.abs(this.scrollable.y) / Math.abs(posY));
		};

		HtpScreen.prototype.handleCommand = function (command, isMouseWheel) {
			if (command === 'Down' || command === 'Up') {
				var scrollDelta = 40;
				if (command === 'Down') {
					this.scrollTo(this.scrollable.y - scrollDelta);
				} else {
					this.scrollTo(this.scrollable.y + scrollDelta);
				}
			}
		};

		HtpScreen.prototype.doScroll = function (e) {
			if (this.scrollableFakeHeight < Absolute.Coords.y(1080)) return;
			var deltaY = 0;
			if (!e) e = window.event;
			if (e.wheelDelta) {
				deltaY = e.wheelDelta / 15;
			} else if (e.detail) {
				deltaY = -e.detail / 3;
			}
			this.scrollTo(this.scrollable.y + (deltaY * 100));
			e.preventDefault();
		};

		HtpScreen.prototype.handleCommand = function (command, isMouseWheel) {
			if (isMouseWheel) return;
			this.selectSection(command, isMouseWheel);
			switch (command) {
				case 'Right': {
					if (!this.sectionSelected) return;
					this.controlFocusManager.focusNextControl(1);
					if (!isMouseWheel) {
						this.scrollToCurrentFocused()
					}
					break;
				}
				case 'Left': {
					if (!this.sectionSelected) return;
					this.controlFocusManager.focusNextControl(-1);
					if (!isMouseWheel) {
						this.scrollToCurrentFocused()
					}
					break;
				}
				case 'Up': {
					if (this.controlFocusManager.getCurrentControl()) {
						if (this.controlFocusManager.focusNextControl(-1)) {
							this.startScrolling(-2);
						} else {
							this.scrollToCurrentFocused()
						}
					} else {
						this.startScrolling(-2);
					}
					break;
				}
				case 'Down': {
					if (this.controlFocusManager.getCurrentControl()) {
						if (this.controlFocusManager.focusNextControl(1)) {
							this.startScrolling(2);
						} else {
							this.scrollToCurrentFocused()
						}
					} else {
						this.startScrolling(2);
					}
					break;
				}
				case 'Activate':
					this.controlFocusManager.activateCurrentControl();
					break;
				case 'Unfocus':
					this.controlFocusManager.unfocusCurrentControl();
					break;
			}

		};

		HtpScreen.prototype.scrollToCurrentFocused = function () {
			current = this.controlFocusManager.getCurrentControl();
			this.scrollTo(-current._bounds.y + current.height * 2);
		};

		HtpScreen.prototype.handlePageChange = function (from, to) {
			switch (to) {
				case 0:
					this.controlFocusManager.setFocusGroup('LeftButtons');
					break;
				case 1:
					this.controlFocusManager.setFocusGroup('RightButtons');
					break;
				case 2:
					this.controlFocusManager.setFocusGroup('HtpPage');
			}
		};

		HtpScreen.prototype.startScrolling = function (delta) {
			this.sidebar.updateByArrow(delta);
		};

		HtpScreen.prototype.selectSection = function (command, isMouseWheel) {
			if (command === 'Tab' || command === 'ShiftTab') {
				this.controlFocusManager.focusCurrentControl();
				this.sectionSelected = true;
				if (command === 'Tab') {
					if (this.page === 2) {
						this.handlePageChange(this.page, 0);
						this.page = 0;
					} else {
						this.controlFocusManager.nextFocusGroup();
					}
				} else if (command === 'ShiftTab') {
					if (this.page === 0) {
						this.handlePageChange(this.page, 2);
						this.page = 2;
					} else {
						this.controlFocusManager.prevFocusGroup();
					}
				}
				switch (this.controlFocusManager.currentFocusGroup) {
					case 'LeftButtons':
						this.page = 0;
						break;
					case 'RightButtons':
						this.page = 1;
						break;
					case 'HtpPage':
						this.page = 2;
						break;
				}
				var current = this.controlFocusManager.getCurrentControl();
				if (!isMouseWheel) {
					this.scrollTo(-current._bounds.y + current.height * 2);
				}
			}
		};

		HtpScreen.prototype.handleGameInput = function () {
			this.resetControlManager();
		};

		HtpScreen.prototype.resetControlManager = function () {
			this.controlFocusManager.unfocusCurrentControl();
		};


		return HtpScreen;
	});

